import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Form, Button, ButtonGroup } from 'react-bootstrap';
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
import VerificarPermisos from '../Tools/VerificarPermisos';
const server = process.env.REACT_APP_SERVER;

//const productos = [{ 'id': 1, 'nombre': 'POLLO', 'idProductos': [1,2,3,4,5,6,7] }, 
//{ 'id': 2, 'nombre': 'PIPOCA', 'idProductos': [111, 1801]},]

function ReportePollosAlmacenes() {

    const { loading, setLoading } = useContext(ContextGloball);
    const [listaProductos, setListaProductos] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    const [regional, setRegional] = useState(0);
    const [almacenes, setAlmacenes] = useState([]);
    const [almacen, setAlmacen] = useState(0);

    async function getAlmacenes(regionActual) {

        try {
            var response = await fetch(`${server}/reporte/getAlmacenes`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': regionActual
                })
            });
            if (response.ok) {

                let datos = await response.json();
                console.log(datos);

                let idsAlmacenesPermitidos = [];

                if (VerificarPermisos.validarPermiso('74') == true) {
                    idsAlmacenesPermitidos.push(2)
                }
                if (VerificarPermisos.validarPermiso('75') == true) {
                    idsAlmacenesPermitidos.push(5)
                }
                if (VerificarPermisos.validarPermiso('76') == true) {
                    idsAlmacenesPermitidos.push(6)
                }
                if (VerificarPermisos.validarPermiso('77') == true) {
                    idsAlmacenesPermitidos.push(1)
                }
                if (VerificarPermisos.validarPermiso('78') == true) {
                    idsAlmacenesPermitidos.push(13)
                }

                let almacenesPermitidos = datos.ok.filter(almacen => idsAlmacenesPermitidos.includes(almacen.ID_ALMACEN))
                setAlmacenes(almacenesPermitidos);
                getProductosDeAlmacen(almacenesPermitidos[0].ID_ALMACEN);
            } else {
                setLoading(false);
                MsgUtils.msgError("No se pudo obtener los almacenes");
            }
        } catch (networkError) {
            MsgUtils.msgError("No se pudo conectar con la base de datos: " + networkError.message);
        }

    }

    async function getProductosDeAlmacen(idAlmacen) {

        let id_sucursal = 0;

        if (idAlmacen == 13) {
            id_sucursal = 24;
        }

        let almacen = parseInt(idAlmacen);

        var info = JSON.parse(localStorage.getItem('info'));

        try {
            let response = await fetch(`${server}/reporte/getProductosAlmacenes`,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'regional': info.ID_REGIONAL_ACTUAL,
                        'id_sucursal': id_sucursal,
                        'id_almacen': almacen,
                    })

                });

            if (response.ok) {
                let datos = await response.json();
                console.log(datos)
                setListaProductos(datos.ok)
                setLoading(false);
            } else {
                setLoading(false);
                MsgUtils.msgError("No se pudo obtener los productos del almacen seleccionado");
            }

        } catch (error) {
            MsgUtils.msgError("No se pudo obtener los productos del almacen seleccionado: " + error.message);
            setLoading(false);
        }
    }

    useEffect(() => {

        var info = JSON.parse(localStorage.getItem('info'));
        setRegional(info.ID_REGIONAL_ACTUAL);
        setLoading(true);
        getAlmacenes(info.ID_REGIONAL_ACTUAL);

    }, [actualizar]);

    return (
        <div>
            <div className='container-fluid bg-dark bg-gradient py-2'>
                <Row>
                    <Col xs={12} sm={6} md={3}>
                        <Form.Group>
                            <Form.Label className="text-white m-0">Seleccione un almacen</Form.Label>
                            <Form.Select
                                value={almacen}
                                onChange={(e) => { setAlmacen(e.target.value); getProductosDeAlmacen(e.target.value) }}
                            >
                                {almacenes.map((almacen, index) => {
                                    return (
                                        <option key={almacen.ID_ALMACEN} value={almacen.ID_ALMACEN}>{almacen.DESCRIPCION}</option>
                                    )
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    {false &&
                        <Col xs={12} sm={6} md={2}>
                            <div className='pt-4'>
                                <button className='btn btn-success bg-gradient w-100' onClick={() => setActualizar(!actualizar)}>
                                    <i className="fa-solid fa-spinner"></i> Actualizar
                                </button>
                            </div>
                        </Col>
                    }
                </Row>
            </div>

            {loading === false &&
                <div className='container-fluid py-2 table-responsive'>
                    <table className="table table-sm table-striped table-hover">
                        <thead>
                            <tr>
                                <th scope="col">DESCRIPCION</th>
                                <th scope="col">STOCK</th>
                                <th scope="col">UNIDAD</th>
                            </tr>
                        </thead>
                        <tbody>

                            {
                                listaProductos.length === 0 ? (
                                    <tr>
                                        <td colSpan="3" className="text-center">No se encontraron productos para este almacen</td>
                                    </tr>
                                ) : (
                                    listaProductos.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{item.DESCRIPCION}</td>
                                                <td style={{ color: item.CANTIDAD < 0 ? 'red' : 'inherit' }}>
                                                    {item.CANTIDAD.toFixed(2)}
                                                </td>
                                                <td>{item.UNIDAD}</td>
                                            </tr>
                                        );
                                    })
                                )
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    )
}

export default ReportePollosAlmacenes
